import { Fragment, type FunctionComponent } from 'react'
import { type INode } from '@shared/lib/ris.types'
import ListItem from './ListItem'
import { Stack } from '@christiankaindl/lyts'
import Inline from '../Inline/Inline'
import Text from '@shared/components/Text/Text'

const List: FunctionComponent<INode> = function List({ ...lists }) {
  return (
    <Stack gap={0.75}>
      {lists.children?.map?.((list, index) => {
        if (typeof list === 'string') {
          return <Text key={index}>{list}</Text>
        }

        if (list.type === 'schlussteil') {
          return (
            <Text
              key={index}
              style={{
                marginTop: -12,
                paddingLeft: `calc(1.5em * ${(list.ebene as string) ?? '0'})`,
              }}
            >
              <Inline {...list} /> {/* Renders "schluss" elements */}
            </Text>
          )
        }

        return (
          <Fragment key={index}>
            {list?.children?.map((child, index) => {
              if (typeof child === 'string') {
                return <ListItem key={index} ebene={list.ebene} value={child} />
              }

              return <ListItem key={index} ebene={list.ebene} {...child} />
            })}

            {list.value !== undefined && (
              <Text
                style={{
                  marginTop: -12,
                  paddingLeft: `calc(1.5em * ${(list.ebene as string) ?? '1'})`,
                }}
              >
                <Inline {...list} /> {/* Renders "schluss" elements */}
              </Text>
            )}
          </Fragment>
        )
      })}
    </Stack>
  )
}

export default List
